<template>
    <div class="flex justify-between items-center gap-4">
        <div>
            <button
                type="button"
                class="btn-base btn-hollow"
                @click="back()"
                v-if="redemptionStep > 1"
                id="hs-redemption-step-back"
            >
                Back
            </button>
        </div>
        <div class="flex gap-4">
            <button
                type="button"
                class="btn-base btn-hollow"
                @click="tripsStore.closeModal()"
                id="hs-redemption-step-cancel"
            >
                Cancel
            </button>
            <button
                type="button"
                class="btn-base btn-dark dark:bg-slate-700 dark:hover:bg-slate-600"
                @click="handleRedemptionAction()"
                :id="
                    redemptionStep < steps.length
                        ? 'hs-redemption-step-next'
                        : 'hs-redemption-step-add'
                "
            >
                {{ btnAction }}
            </button>
        </div>
    </div>
</template>
<script setup>
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useTripsStore } from '@/store/trips';
import HsTracking from '@/services/hs-tracking';

const tripsStore = useTripsStore();
const { steps, redemptionStep, tripFormErrors } =
    storeToRefs(tripsStore);

const btnAction = computed(() => {
    if (redemptionStep.value < steps.value.length) {
        return 'Next';
    }
    return 'Add';
});

const handleRedemptionAction = async () => {
    tripsStore.validateRedemption();

    if (Object.keys(tripFormErrors.value).length === 0) {
        if (redemptionStep.value === steps.value.length) {
            await tripsStore.createRedemption();
            HsTracking.trackCustomEvent(
                'pe22692776_completed_adding_a_redemption',
                {
                    redemption: tripsStore.activeRedemption,
                }
            );
        } else {
            redemptionStep.value = redemptionStep.value + 1;
        }
    }
};

const back = () => {
    if (redemptionStep.value === 1) {
        return;
    }
    redemptionStep.value = redemptionStep.value - 1;
};
</script>
